export default __webpack_public_path__ + "static/media/group_users.27faa5d4.svg";